export function disableScroll() {
    document.documentElement.classList.add( 'no-scroll' );
}

export function enableScroll() {
    document.documentElement.classList.remove( 'no-scroll' );
}